export class PrivacyModalData {
  constructor(public usePrionTemplate: boolean) { }
}
